import PropTypes from 'prop-types';

const LayoutGridIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(0.000000, -6.000000)" fill={fill}>
          <path d="M46.5,6 C47.3284271,6 48,6.67157288 48,7.5 L48,40.5 C48,41.3284271 47.3284271,42 46.5,42 L1.5,42 C0.671572875,42 1.01453063e-16,41.3284271 0,40.5 L0,7.5 C-1.01453063e-16,6.67157288 0.671572875,6 1.5,6 L46.5,6 Z M21.75,26.25 L4.5,26.25 L4.5,36.75 C4.5,37.1642136 4.83578644,37.5 5.25,37.5 L5.25,37.5 L21.75,37.5 L21.75,26.25 Z M43.5,26.25 L26.25,26.25 L26.25,37.5 L42.75,37.5 C43.1642136,37.5 43.5,37.1642136 43.5,36.75 L43.5,26.25 Z M21.75,10.5 L5.25,10.5 C4.83578644,10.5 4.5,10.8357864 4.5,11.25 L4.5,11.25 L4.5,21.75 L21.75,21.75 L21.75,10.5 Z M42.75,10.5 L26.25,10.5 L26.25,21.75 L43.5,21.75 L43.5,11.25 C43.5,10.8357864 43.1642136,10.5 42.75,10.5 Z" />
        </g>
      </g>
    </svg>
  </div>
);

LayoutGridIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

LayoutGridIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default LayoutGridIcon;
